import { render, staticRenderFns } from "./clubLanding.vue?vue&type=template&id=1d3d37ba&scoped=true"
import script from "./clubLanding.vue?vue&type=script&lang=js"
export * from "./clubLanding.vue?vue&type=script&lang=js"
import style0 from "./clubLanding.vue?vue&type=style&index=0&id=1d3d37ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3d37ba",
  null
  
)

export default component.exports